import { CHUser } from "../tsClasses/CHTypes";
import { apiPath } from "./GeneralFunc";

type UpdateUserFuncProps = {
  userToUpdate : CHUser,
  userToken: string,
}

const UpdateUserFunc = async (props : UpdateUserFuncProps) => {
    
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", token: props.userToken },
      body: JSON.stringify(props.userToUpdate),
    };

  
    try {
      const response = await fetch(
        apiPath+"/admin/updateUser",
        requestOptions
      );
      if (response.status == 401) {
        return "Unauthorized";
      }
      if (response == null) {
      }
  
      const result = await response.text();
      return result;
    } catch (error) {
      return "gotErr";
    }
  };
  export default UpdateUserFunc;